import { AddSupplierFormModalContext } from "@/contexts"
import { useContext } from "react"

export const useAddSupplierFormModalContext = () => {
  const context = useContext(AddSupplierFormModalContext)

  if (!context) throw new Error('useAddSupplierFormModalContext has to be wrapped by AddSupplierFormModalContextPropvider')

  return context
}
